import { effect, inject, signal, Service } from '@angular/core';
import { Router } from '@angular/router';
import { NetworkStatusService } from './offline/network-status.service';
import { AppToastService } from './app-toast.service';

@Service()
export class NetworkToastBridgeService {
  private readonly networkStatusService = inject(NetworkStatusService);
  private readonly appToastService = inject(AppToastService);
  private readonly router = inject(Router);

  private readonly wasOffline = signal(false);
  private readonly onlineToastId = signal<string | null>(null);

  constructor() {
    effect(() => {
      const isOnline = this.networkStatusService.online();
      if (this.router.url.includes('/auth')) {
        return;
      }
      if (!isOnline) {
        queueMicrotask(() => {
          this.appToastService.showNetworkOffline();
          this.wasOffline.set(true);
        });
      } else if (this.wasOffline()) {
        queueMicrotask(() => {
          this.onlineToastId.set(this.appToastService.showNetworkOnline());
        });
      }
    });

    effect(() => {
      const id = this.onlineToastId();
      if (!id) {
        return;
      }
      const present = this.appToastService
        .activeToasts()
        .some(toast => toast.id === id);
      if (!present) {
        queueMicrotask(() => {
          this.onlineToastId.set(null);
          this.wasOffline.set(false);
        });
      }
    });
  }
}
